<template>
  <div style="position: relative;" class="my-chart-parent" :style="parentStyle">
    <div ref="analysis" class="my-chart" :style="chartStyle" ></div>
  </div>

</template>

<script>

export default {
  name: "myChart",
  props:['type','chartData','width','height','border','barWidthScale','chartTitle'],
  data(){
    return {
      title:[],
      value:[],
      chartStyle:{
        width:this.width+'px',
        height:this.height+'px',
      },
      parentStyle:{
        width:this.width+5+'px',
        height:this.height+30+'px',
      }
    }
  },
  computed:{
    option(){
      switch (this.type){
        case 'bar':
          this.chartData.forEach((item)=>{
            let title = Object.values(item)[0];
            this.title.push(title)
          });
          this.chartData.filter((item)=>{
            let value =Object.values(item)[1];
            this.value.push(value);
          });
          break;
        case 'pie':
          this.title = ''
          this.value = this.chartData
          break;
      }
      let barOption = {
          title:{
            text:this.chartTitle,
            left:'center'
          },
          tooltip:{
            trigger:'item',
            formatter:'{a}<br/>{b}：{c}'
          },
          xAxis: {data: this.title},
          yAxis: {},
          series: [{
              name:'活跃用户数量',
              type: this.type,
              data: this.value,
              barWidth:this.barWidthScale?this.barWidthScale:'',
          }],
          itemStyle:{
            barBorderRadius: 4,
            shadowColor: '#5470c6',
            shadowBlur: 2
          }
      }
      let pieOption = {
        title:{
          text:this.chartTitle,
          left:'center'
        },
        tooltip:{
          trigger:'item',
          formatter:'{a}<br/>{b}：{c}%'
        },
        series: [{
          name:'活跃用户比例',
          type: this.type,
          data: this.value,
          radius:'70%',
          barWidth:this.barWidthScale?this.barWidthScale:'',
        }],
        itemStyle:{
          barBorderRadius: 4,
          shadowColor: '#5470c6',
          shadowBlur: 2
        }
      };
      return this.type==='bar'?barOption:pieOption;
    },

  },
  methods:{
    drawChart(){
      const analysis = this.$refs.analysis;
      if(analysis){
        const mycharts = this.$charts.init(analysis);
        mycharts.setOption(this.option);
        window.addEventListener("resize", function() {
          mycharts.resize();
        });
        this.$on('hook:destroyed',()=>{
          window.removeEventListener("resize", function() {
            mycharts.resize();
          });
        });
      }
    }
  },
  watch:{
    chartData:{
      deep:true,
      handler(){
        this.drawChart();
      }
    }
  },
  mounted() {
    this.drawChart();
  }
}
</script>

<style scoped>


</style>
